(() => {
  class DigiInstantGift {
    constructor(section) {
      this.section = section;
      this.screens = section.querySelectorAll("[data-screen]");
      this.progress = section.querySelectorAll("[data-step]");
      this.progressFill = section.querySelector("[data-digift-progress-fill]");

      this.startButton = section.querySelector("[data-digift-start]");
      this.startButtonLabel = section.querySelector("[data-digift-start-label]");
      this.startButtonLoader = section.querySelector("[data-digift-button-loader]");
      this.claimButton = section.querySelector("[data-digift-claim]");
      this.vipLinks = section.querySelectorAll("[data-digift-vip-link]");

      this.loadingTitle = section.querySelector("[data-digift-loading-title]");
      this.loadingText = section.querySelector("[data-digift-loading-text]");
      this.form = section.querySelector("[data-digift-form]");

      this.nameInput = section.querySelector("[data-digift-name]");
      this.emailInput = section.querySelector("[data-digift-email]");
      this.phoneInput = section.querySelector("[data-digift-phone]");
      this.cpfInput = section.querySelector("[data-digift-cpf]");
      this.consentInput = section.querySelector("[data-digift-consent]");
      this.feedback = section.querySelector("[data-digift-feedback]");

      this.playEndpoint = section.dataset.playEndpoint;
      const eventConfig = section.querySelector("[data-digift-event-config]");
      this.eventConfig = eventConfig ? JSON.parse(eventConfig.textContent) : {};
      this.config = { ...window.InstantGiftConfig, campaignKey: section.dataset.campaign };
      this.isEvent = section.dataset.mode === "events";
      this.isTest = section.dataset.testMode === "true";
      this.testResult = section.dataset.testResult || "AA2011";
      section.querySelector("[data-digift-test-reset]")?.addEventListener("click", () => {
        if (this.isSubmitting || this.isConfirming) return;
        this.clearDeliveryState();
        this.playResponse = null;
        this.stopLoading();
        this.changeState("register");
        this.updateProgress(1);
        this.setFeedback();
      });
      this.isConfirming = false;
      this.eventConfirm = section.querySelector("[data-digift-event-confirm]");
      this.eventConfirm?.addEventListener("click", () => this.confirmDelivery());

      this.loadingTimer = null;
      this.playResponse = null;
      this.isSubmitting = false;

      this.loadingSteps = [
        {
          title: "CONFERINDO CADASTRO...",
          text: "Validando suas informações."
        },
        {
          title: "EMBARALHANDO BRINDES...",
          text: "Preparando sua surpresa."
        },
        {
          title: "DESCOBRINDO RESULTADO...",
          text: "Só mais alguns segundos."
        }
      ];

      this.setUtms();
      this.bindEvents();
      this.updateProgress(1);
      this.restoreDeliveryState();
    }

    setUtms() {
      if (!this.form) return;

      const params = new URLSearchParams(window.location.search);

      const utmFields = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term"
      ];

      utmFields.forEach(fieldName => {
        const field = this.form.elements[fieldName];

        if (!field) return;

        const value = params.get(fieldName);

        if (value) {
          field.value = value;
        }
      });
    }

    bindEvents() {
      this.form?.addEventListener("submit", event => {
        event.preventDefault();
        this.submit();
      });

      this.claimButton?.addEventListener("click", event => {
        event.preventDefault();
        this.claim();
      });

    [this.nameInput, this.emailInput, this.phoneInput, this.cpfInput]
      .filter(Boolean)
      .forEach(field => {
        field.addEventListener("input", () => {

          if (field === this.phoneInput) {
            field.value = this.formatPhone(field.value);
          }

          if (field === this.cpfInput) {
            field.value = this.formatCpf(field.value);
          }

          this.setFieldValidities();
          this.setFieldState(field, field.checkValidity());
          this.updateButtonState();
        });

        field.addEventListener("blur", () => {
          this.setFieldValidities();
          this.setFieldState(field, field.checkValidity());
        });
      });

      this.consentInput?.addEventListener("change", () => {
        this.setConsentState(this.consentInput.checked);
        this.updateButtonState();
      });

      this.setFieldValidities();
      this.updateButtonState();
    }

    onlyDigits(value) {
      return String(value || "").replace(/\D/g, "");
    }

    formatPhone(value) {
      const phone = this.onlyDigits(value).slice(0, 11);

      if (phone.length <= 2) {
        return phone;
      }

      if (phone.length <= 6) {
        return `(${phone.slice(0, 2)}) ${phone.slice(2)}`;
      }

      if (phone.length <= 10) {
        return `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6)}`;
      }

      return `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`;
    }

    formatCpf(value) {
      const cpf = this.onlyDigits(value).slice(0, 11);

      if (cpf.length <= 3) {
        return cpf;
      }

      if (cpf.length <= 6) {
        return `${cpf.slice(0, 3)}.${cpf.slice(3)}`;
      }

      if (cpf.length <= 9) {
        return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6)}`;
      }

      return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9)}`;
    }

    isValidCpf(value) {
      const cpf = this.onlyDigits(value);

      if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
        return false;
      }

      const calculateDigit = length => {
        let total = 0;

        for (let index = 0; index < length; index++) {
          total += Number(cpf[index]) * (length + 1 - index);
        }

        const remainder = (total * 10) % 11;
        return remainder === 10 ? 0 : remainder;
      };

      return (
        calculateDigit(9) === Number(cpf[9]) &&
        calculateDigit(10) === Number(cpf[10])
      );
    }

    setFeedback(message = "") {
      if (!this.feedback) return;

      this.feedback.textContent = message;
      this.feedback.hidden = !message;
    }

    setFieldValidities() {
      const name = this.nameInput.value.trim();
      const phone = this.onlyDigits(this.phoneInput.value);

      this.nameInput.setCustomValidity(
        name ? "" : "Informe seu nome."
      );

      this.phoneInput.setCustomValidity(
        phone.length === 10 || phone.length === 11
          ? ""
          : "Informe um WhatsApp válido com DDD."
      );

      if (this.cpfInput) {
        this.cpfInput.setCustomValidity(
          this.isValidCpf(this.cpfInput.value) ? "" : "Informe um CPF válido."
        );
      }
    }

    setFieldState(field, isValid) {
      if (!field) return;

      field.classList.toggle("is-invalid", !isValid);
      field.setAttribute("aria-invalid", String(!isValid));
    }

    setConsentState(isValid) {
      const consent = this.consentInput?.closest(
        ".digi-instant-gift__consent"
      );

      consent?.classList.toggle("is-invalid", !isValid);
      this.consentInput?.setAttribute(
        "aria-invalid",
        String(!isValid)
      );
    }

    isFormReady() {
      this.setFieldValidities();

      const fields = [
        this.nameInput,
        this.emailInput,
        this.phoneInput,
        this.cpfInput
      ].filter(Boolean);

      return (
        fields.every(field => field && field.checkValidity()) &&
        Boolean(this.consentInput?.checked)
      );
    }

    updateButtonState() {
      if (!this.startButton) return;

      this.setFieldValidities();

      const fieldsReady = [
        this.nameInput,
        this.emailInput,
        this.phoneInput,
        this.cpfInput
      ].filter(Boolean).every(field => field.checkValidity());

      this.setConsentState(
        !fieldsReady || Boolean(this.consentInput?.checked)
      );

      const isDisabled = this.isSubmitting || (!this.isTest && !this.isFormReady());

      this.startButton.disabled = isDisabled;
      this.startButton.setAttribute(
        "aria-disabled",
        String(isDisabled)
      );
    }

    validate() {
      this.setFeedback();
      this.setFieldValidities();

      const fields = [
        this.nameInput,
        this.emailInput,
        this.phoneInput,
        this.cpfInput
      ].filter(Boolean);

      fields.forEach(field => {
        this.setFieldState(field, field.checkValidity());
      });

      this.setConsentState(Boolean(this.consentInput?.checked));

      const invalidField = fields.find(
        field => field && !field.checkValidity()
      );

      if (invalidField) {
        invalidField.focus();
        return false;
      }

      if (!this.consentInput.checked) {
        this.consentInput
          .closest(".digi-instant-gift__consent")
          ?.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });

        return false;
      }

      return true;
    }

    async hashCpf(value) {
      const cpf = this.onlyDigits(value);
      const encodedCpf = new TextEncoder().encode(cpf);
      const hashBuffer = await crypto.subtle.digest("SHA-256", encodedCpf);

      return Array.from(new Uint8Array(hashBuffer))
        .map(byte => byte.toString(16).padStart(2, "0"))
        .join("");
    }

    async getPayload() {
      return {
        campaign_key: this.config.campaignKey,
        name: this.nameInput.value.trim(),
        email: this.emailInput.value.trim(),
        phone: this.onlyDigits(this.phoneInput.value),
        cpf_hash: this.cpfInput ? await this.hashCpf(this.cpfInput.value) : null,
        privacy_consent: this.consentInput.checked,
        utm_source: this.form.elements.utm_source?.value || "",
        utm_medium: this.form.elements.utm_medium?.value || "",
        utm_campaign: this.form.elements.utm_campaign?.value || "",
        utm_content: this.form.elements.utm_content?.value || "",
        utm_term: this.form.elements.utm_term?.value || ""
      };
    }

    async play() {
      if (this.isTest) {
        return {
          result: ["kit", "test_winner"].includes(this.testResult) ? "winner" : "loser",
          product: ["redeemed", "test_winner", "test_loser"].includes(this.testResult) ? "AA2011" : this.testResult,
          participation_status: this.testResult === "redeemed" ? "redeemed" : "assigned",
          already_participated: this.testResult === "redeemed"
        };
      }
      const payload = await this.getPayload();

      const response = await fetch(this.playEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      let data;

      try {
        data = await response.json();
      } catch (error) {
        throw new Error("O servidor retornou uma resposta inválida.");
      }

      if (this.isEvent && data.participation_status === "redeemed" &&
          (response.ok || response.status === 409)) {
        return data;
      }

      if (!response.ok || data.status === "error") {
        throw new Error(
          data.message ||
          data.error ||
          "Não foi possível processar sua participação."
        );
      }

      return data;
    }

    setSubmitting(isSubmitting) {
      this.isSubmitting = isSubmitting;

      if (this.startButton) {
        this.startButton.setAttribute(
          "aria-busy",
          String(isSubmitting)
        );
        this.updateButtonState();
      }

      if (this.startButtonLabel) {
        this.startButtonLabel.hidden = isSubmitting;
      }

      if (this.startButtonLoader) {
        this.startButtonLoader.hidden = !isSubmitting;
      }
    }

    trackLead(result) {
      if (this.isTest || window.__digiInstantGiftLeadTracked) {
        return;
      }

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "lead_stape",

        event_category: "Lead",
        event_label: "Instant Gift",
        campaign: this.config.campaignKey || "instant_gift",
        result_status: result,

        user_data: {
          email: this.emailInput.value.trim().toLowerCase(),
          phone: this.onlyDigits(this.phoneInput.value)
        }
      });

      window.__digiInstantGiftLeadTracked = true;
    }

    async submit() {
      if (this.isSubmitting || (!this.isTest && !this.validate())) {
        return;
      }

      const loadingStartedAt = Date.now();
      const minimumLoadingTime = 3000;

      this.setSubmitting(true);
      this.changeState("loading");
      this.updateProgress(2);
      this.playLoading();

      try {
        const response = await this.play();
        const elapsedTime = Date.now() - loadingStartedAt;
        const remainingTime = Math.max(
          0,
          minimumLoadingTime - elapsedTime
        );

        if (remainingTime > 0) {
          await new Promise(resolve => {
            setTimeout(resolve, remainingTime);
          });
        }


        if (this.isEvent) {
          this.playResponse = response;
          this.renderEventResult(response);
          if (response.already_participated === false &&
              response.participation_status !== "redeemed") {
            this.trackLead(response.result);
          }
          this.showResult("event");
          return;
        }
        const result = response?.result;

        if (result !== "winner" && result !== "loser") {
          throw new Error("O servidor não retornou um resultado válido.");
        }

        this.playResponse = response;

        this.trackLead(result);

        this.setVipLink(response.vip_url);

        this.showResult(
          this.section.dataset.mode === "vip_capture" ? "vip" : (result === "winner" ? "win" : "lose")
        );
      } catch (error) {
        this.stopLoading();
        this.changeState("register");
        this.updateProgress(1);
        this.setFeedback(
          error.message ||
          "Não foi possível processar sua participação. Tente novamente."
        );
      } finally {
        this.setSubmitting(false);
      }
    }

    renderEventResult(response) {
      const redeemed = response.participation_status === "redeemed";
      const names = {
        AA2011: this.eventConfig.names?.AA2011 || "Bombom Crocante",
        AA2007: this.eventConfig.names?.AA2007 || "Cookies & Cream",
        AA02221: this.eventConfig.names?.AA02221 || "Doce de Leite",
        AA2015: this.eventConfig.names?.AA2015 || "Trufa de Chocolate"
      };
      const kit = response.result === "winner";
      if (!redeemed && response.result !== "winner" && response.result !== "loser") {
        throw new Error("O servidor não retornou um prêmio válido.");
      }
      if (!redeemed && response.prize_type &&
          response.prize_type !== (kit ? "kit" : "sample")) {
        throw new Error("O servidor retornou informações de prêmio inconsistentes.");
      }
      const name = kit ? this.eventConfig.kitName : names[response.product];
      if (!redeemed && !name) {
        throw new Error("Não foi possível identificar o sabor reservado. Procure nossa equipe.");
      }
      this.section.querySelector("[data-digift-event-title]").textContent =
        redeemed ? "BRINDE RESGATADO!" :
          kit ? this.eventConfig.kitTitle : this.eventConfig.sampleTitle;
      this.section.querySelector("[data-digift-event-description]").textContent =
        redeemed ? this.eventConfig.redeemedText : this.eventConfig.pendingText;
      const prize = this.section.querySelector("[data-digift-event-prize]");
      prize.textContent = name || "";
      prize.hidden = !name;
      const image = this.section.querySelector("[data-digift-event-image]");
      const imageUrl = this.eventConfig.images?.[kit ? "kit" : response.product];
      this.section.querySelector("[data-digift-event-image-wrap]").hidden = !imageUrl;
      if (imageUrl) {
        image.src = imageUrl;
        image.alt = name || "";
      } else {
        image.removeAttribute("src");
      }
      this.section.querySelector("[data-digift-event-delivery]").hidden = redeemed;
      this.eventConfirm.disabled = redeemed;
      this.eventConfirm.textContent = this.eventConfig.confirmLabel;
      this.setEventFeedback();
    }

    setEventFeedback(message = "") {
      const feedback = this.section.querySelector("[data-digift-event-feedback]");
      feedback.textContent = message;
      feedback.hidden = !message;
    }

    deliveryStorageKey() {
      return JSON.stringify([
        "digi-instant-gift-delivery",
        window.location.pathname,
        this.section.dataset.sectionId,
        this.config.campaignKey,
        this.isTest ? "test" : "live"
      ]);
    }

    clearDeliveryState() {
      try {
        window.sessionStorage.removeItem(this.deliveryStorageKey());
      } catch {}
    }

    restoreDeliveryState() {
      if (!this.isEvent) return;
      try {
        const saved = JSON.parse(window.sessionStorage.getItem(this.deliveryStorageKey()));
        if (!saved || saved.participation_status !== "redeemed") return;
        if (saved.result !== "winner" && saved.result !== "loser") {
          this.clearDeliveryState();
          return;
        }
        this.playResponse = saved;
        this.renderEventResult(saved);
        this.showResult("event");
      } catch {
        this.clearDeliveryState();
      }
    }

    confirmDelivery() {
      if (this.isConfirming || this.eventConfirm.disabled || !this.playResponse) return;
      const saved = {
        result: this.playResponse.result,
        product: this.playResponse.product,
        participation_status: "redeemed"
      };
      this.isConfirming = true;
      this.eventConfirm.disabled = true;
      this.eventConfirm.textContent = "Recarregando...";
      try {
        window.sessionStorage.setItem(this.deliveryStorageKey(), JSON.stringify(saved));
      } catch {
        this.playResponse = saved;
        this.renderEventResult(saved);
        this.showResult("event");
        this.isConfirming = false;
        return;
      }
      window.location.reload();
    }

    claim() {
      if (this.isTest) {
        const feedback = this.section.querySelector("[data-digift-claim-feedback]");
        if (feedback) {
          feedback.textContent = "Resgate simulado. Nenhum checkout será aberto no modo teste.";
          feedback.hidden = false;
        }
        return;
      }
      const checkoutUrl = this.playResponse?.claim?.checkout_url;

      if (!checkoutUrl) {
        const claimFeedback = this.section.querySelector(
          "[data-digift-claim-feedback]"
        );

        if (claimFeedback) {
          claimFeedback.textContent =
            "Não foi possível abrir o checkout. Tente novamente.";
          claimFeedback.hidden = false;
        }

        return;
      }

      window.location.assign(checkoutUrl);
    }

    /* ==========================
      LINK GRUPO VIP
    ========================== */
    setVipLink(url) {
      // O link configurado no metaobjeto da campanha tem prioridade.
      // A resposta do sorteio so serve como fallback quando ele estiver vazio.
      const configuredUrl = (this.section.dataset.whatsappUrl || "").trim();
      const destination = configuredUrl || (typeof url === "string" ? url.trim() : "");
      if (!destination || !/^https?:\/\//i.test(destination)) return;
      this.vipLinks.forEach(link => {
        if (link.dataset.digiftVipOverride === "true") return;
        link.href = destination;
      });
    }

    playLoading() {
      let index = 0;

      const nextStep = () => {
        if (index >= this.loadingSteps.length) {
          index = 0;
        }

        const step = this.loadingSteps[index];

        if (this.loadingTitle) {
          this.loadingTitle.textContent = step.title;
        }

        if (this.loadingText) {
          this.loadingText.textContent = step.text;
        }

        index++;
        this.loadingTimer = setTimeout(nextStep, 1000);
      };

      nextStep();
    }

    stopLoading() {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
    }

    showResult(result) {
      this.stopLoading();
      this.changeState(result);
      this.updateProgress(3);
    }

    changeState(state) {
      this.screens.forEach(screen => {
        const isActive = screen.dataset.screen === state;
        screen.classList.toggle("is-active", isActive);
        screen.setAttribute("aria-hidden", String(!isActive));
      });
    }

    updateProgress(step) {
      this.progress.forEach((item, index) => {
        item.classList.toggle("is-active", index < step);
      });

      if (this.progressFill) {
        this.progressFill.style.width = `${34 + (Math.min(Math.max(step, 1), 3) - 1) * 33}%`;
      }
    }
  }

  document.querySelectorAll("[data-digift]").forEach(section => {
    new DigiInstantGift(section);
  });
})();

